import { render, staticRenderFns } from "./custom-loader.vue?vue&type=template&id=121652ba"
import script from "./custom-loader.vue?vue&type=script&lang=js"
export * from "./custom-loader.vue?vue&type=script&lang=js"
import style0 from "./custom-loader.vue?vue&type=style&index=0&id=121652ba&prod&lang=css"


/* normalize component */
import normalizer from "!./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports